import { render } from "./TableSection.vue?vue&type=template&id=3b92778a"
import script from "./TableSection.vue?vue&type=script&lang=js"
export * from "./TableSection.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./TableSection.vue?vue&type=style&index=0&id=3b92778a&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script